import React, { ChangeEvent, useState } from 'react'

import { SectionSubtitle } from '../..'
import { Spacer } from '../../global'
import { Input, PasswordInput } from '../../inputs'
import {
  ChangeCredentialsContainer,
  ChangeEmailContainer,
  ChangePasswordContainer,
} from '../styles'

const CurrentCredentialSection = ({
  credentials,
  handleChange,
  inputClass,
}: {
  credentials: {
    currentPassword?: string
    password: string
    confirmPassword: string
    email?: string
    confirmEmail?: string
    currentEmail: string
  }
  handleChange: (value: string, filterName: string) => void
  inputClass?: string
}) => {
  const [error, setError] = useState<string | null>(null)

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    // Restablecer los mensajes de error
    setError('')

    let errorMessage = ''

    if (name === 'currentPassword' && value === '') {
      errorMessage += '<p>Ingresa la contraseña actual</p>'
    }

    const emailPattern =
      /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(
        value,
      )

    if (name === 'currentEmail' && !emailPattern) {
      setError('No es un email valido')
    }

    setError(errorMessage)

    handleChange(value, name)
  }
  return (
    <ChangeCredentialsContainer>
      <ChangePasswordContainer>
        <SectionSubtitle fontWeight={500} fontSize={12}>
          Contraseña actual*
        </SectionSubtitle>

        <PasswordInput
          fieldName="currentPassword"
          value={credentials.currentPassword ?? ''}
          handleChange={handleChangeInput}
          inputClass={inputClass}
        />
      </ChangePasswordContainer>
      <ChangeEmailContainer>
        <SectionSubtitle fontWeight={500} fontSize={12}>
          Email actual*
        </SectionSubtitle>
        <Spacer height={10} />

        <Input
          id="email"
          name="currentEmail"
          type="email"
          placeholder={credentials.currentEmail}
          // value={credentials.email}
          onChange={handleChangeInput}
          inputClass={inputClass}
        />
      </ChangeEmailContainer>
      {error && (
        <div
          className="error"
          dangerouslySetInnerHTML={{ __html: error }}
        ></div>
      )}
    </ChangeCredentialsContainer>
  )
}

export default CurrentCredentialSection
